// Campo.js
import React from 'react';
import "./CreaEvento.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const Campo = ({ nome, descrizione, onChange , onRemove}) => (
  
<div>
  <div className='portate'>
  
  
    <label>
      Nome:
      <input type="text" name="nome" value={nome} onChange={onChange} />
    </label>

    <label>
      Descrizione:
      <input type="text" name="descrizione" value={descrizione} onChange={onChange} />
    </label>
    
 
    <button type="button" onClick={onRemove}>
      <FontAwesomeIcon icon={faTrash} /> {/* Icona del cestino */}
    </button>
    </div>
  <hr />
  </div>
);

export default Campo;
